var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBscTabSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / blockchain / select / Binance selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-blockchain-/-select-/-Binance-selected",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#4884E8",
    strokeWidth: 2,
    fill: "#4884E8",
    cx: 20,
    cy: 20,
    r: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-blockchain-/-Ethereum"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51934349,12 L4.2586948,14.2586948 L2,12 L4.2586948,9.7413052 L6.51934349,12 Z M12,6.51543572 L15.8706526,10.3880422 L18.1293474,8.1293474 L12,2 L5.8706526,8.1293474 L8.1293474,10.3880422 L12,6.51543572 Z M19.7432591,9.7413052 L17.4845643,12 L19.7432591,14.2586948 L22,12 L19.7432591,9.7413052 Z M12,17.4845643 L8.1293474,13.6139117 L5.8706526,15.8706526 L12,22 L18.1293474,15.8706526 L15.8706526,13.6139117 L12,17.4845643 Z M12,14.2586948 L14.2586948,12 L12,9.7413052 L9.7413052,12 L12,14.2586948 Z",
    id: "path16"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscTabSelected);
export default __webpack_public_path__ + "static/media/bscTabSelected.6fac6733.svg";
export { ForwardRef as ReactComponent };